import { styled } from 'troyfe';

const AnimationModalStyle = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: ${(props) => `${props?.scroll ? 'hidden' : 'auto'}`};
  outline: 0;
  z-index: ${(props) => `${props?.ZIndex ? props?.ZIndex : 1000}`};
  /* z-index: 1000; */

  .ant-modal-close {
    width: 40px;
    height: 72px;
    font-size: 16px;
    line-height: 72px;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    padding: 0;
    color: #00000073;
    font-weight: 700;
    cursor: pointer;
  }

  .wrap {
    border: 1px solid transparent;
    border-radius: 8px;
    background: #ffffff;
    box-sizing: border-box;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: 'tnum';
    box-shadow: 0 2px 8px #f0f1f2;
    /* pointer-events: none; */
    position: relative;
    margin: 0 auto;
    top: 100px;
    width: ${(props) => `${props.width || 520}px`};
    z-index: 1000;

    .animate-modal-header {
      margin-bottom: 40px;
      border-radius: 8px 8px 0 0;
      height: 72px;
      background: #f1f2f4;
      line-height: 72px;
      border-bottom: 1px solid #f0f0f0;
      position: relative;

      .animate-modal-title {
        text-align: center;
        color: #333333;
        //font-weight: bold;
        font-size: 18px;
        font-weight: 500;
      }
    }

    .animate-modal-content {
      text-align: center;
      background-color: #fff;
    }

    .footerModal {
      display: flex;
      justify-content: center;
      padding: 40px 0;
      font-size: 18px;

      .close,
      .confirm {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        margin: 0 10px;
        width: 120px;
        height: 48px;
        cursor: pointer;
      }

      .close {
        border: 1px solid #44bb55;
        color: #44bb55;
      }

      .confirm {
        background: #44bb55;
        color: #fff;
      }
    }
  }
`;
export default AnimationModalStyle;
